import * as React from 'react';
import { s3ToCDN } from '@doltech/utils/lib/url';
import { useControlledAudioPlayInBackgroundStore } from '@doltech/ui/lib/hooks/controlled-audio-play-in-background.store';
import { cacheAudioUrl } from '@doltech/utils/lib/audio';

export const useListeningAudioControlledStore = ({ audioPath, useCache = true }) => {
  const audioUrl = s3ToCDN(audioPath);
  const audioStore = useControlledAudioPlayInBackgroundStore();
  React.useEffect(() => {
    if (useCache) {
      cacheAudioUrl(audioUrl).then((audio) => {
        audioStore.registerUrl(audio);
      });
    } else {
      audioStore.registerUrl(audioUrl);
    }
  }, [audioStore, audioUrl, useCache]);
};
